import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { type DatatableState } from "@/domain/view/models/datatable-state-model";

import { type DatatableRowData } from "../datatable-types";

import { type InternalTableStateProviderProps } from "./datatable-context-props";
import { InternalDataTableContextProvider } from "./internal-data-table-context-provider";
import { resolveDatatableStateFromUrl } from "./resolve-datatable-state-from-url";

export const PrepareInitialContextWithUrlParams = <TData extends DatatableRowData>(
  props: InternalTableStateProviderProps<TData>,
) => {
  const [searchParams] = useSearchParams();

  const [initialDatatableState] = useState<DatatableState>(() => {
    if (!props.initWithUrlParams || props.lockPublishedConfiguration) {
      return props.initialState;
    }

    return resolveDatatableStateFromUrl({
      searchParams,
      columns: props.columns,
      initialState: props.initialState,
    });
  });

  return <InternalDataTableContextProvider {...props} initialState={initialDatatableState} />;
};
